import React, { Fragment } from "react";

const About = () => {
  return (
    <Fragment>
      <h1>About this App</h1>
      <p>App to search Github Users</p>
      <p>
        Created by{" "}
        <a
          href="https://github.com/skamranahmed"
          target="_blank"
          rel="noreferrer"
        >
          Syed Kamran Ahmed
        </a>
      </p>
    </Fragment>
  );
};

export default About;
